module.exports = __webpack_public_path__ + "files/b242256923f8bf876e24aacc8432a4e3.png";